import { z } from 'zod';
import { BOX_FORMATS } from './box.js';

/**
 * Zod-схемы лидерборда (Веха 9 M2, threat-model rewards.md I.b/R-4/R-7).
 *
 * Принципы:
 *   - `group` — формат бокса ∈ BOX_FORMATS | 'all'. Неизвестный формат → 400.
 *   - Response strict: нет userId, нет ownerId (R-4/I.b). Только публичные поля:
 *     boxToken, ownerUsername, counts.
 *   - Cursor `after` — публичный boxToken последней записи; не internal id.
 */

export const LeaderboardPeriodEnum = z.enum(['7d', '30d', 'all']);
export type LeaderboardPeriod = z.infer<typeof LeaderboardPeriodEnum>;

export const LeaderboardGroupEnum = z.enum(['all', ...BOX_FORMATS]);
export type LeaderboardGroup = z.infer<typeof LeaderboardGroupEnum>;

export const LeaderboardQuery = z
  .object({
    period: LeaderboardPeriodEnum.default('7d'),
    group: LeaderboardGroupEnum.default('all'),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    after: z.string().optional(),
  })
  .strict();
export type LeaderboardQuery = z.infer<typeof LeaderboardQuery>;

/**
 * Один элемент лидерборда.
 * Строго: нет userId / ownerId / fingerprint (threat-model rewards.md I.b/R-4).
 */
export const LeaderboardEntrySchema = z
  .object({
    rank: z.number().int().min(1),
    boxToken: z.string(),
    ownerUsername: z.string().nullable(),
    format: z.string(),
    score: z.number().int().min(0),
    questionCount: z.number().int().min(0),
    referralCount: z.number().int().min(0),
  })
  .strict();
export type LeaderboardEntry = z.infer<typeof LeaderboardEntrySchema>;

export const LeaderboardResponse = z
  .object({
    entries: z.array(LeaderboardEntrySchema),
    nextCursor: z.string().nullable(),
  })
  .strict();
export type LeaderboardResponse = z.infer<typeof LeaderboardResponse>;
